import { render, staticRenderFns } from "./adminlogin.vue?vue&type=template&id=1d102dc5&"
import script from "./adminlogin.vue?vue&type=script&lang=js&"
export * from "./adminlogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports